export default {
  addNewTab(state, tab) {
    state.tabs.push(tab);
  },
  updateTabTitle(state, { path, title }) {
    const tab = state.tabs.find(t => t.path === path);

    if (tab) {
      tab.title = title;
    }
  },
  removeTab(state, index) {
    state.tabs.splice(index, 1);
  },
  removeAllTabs(state) {
    state.tabs = [];
  },
  removeInactiveTabs(state, path) {
    state.tabs = state.tabs.filter(tab => tab.path === path);
  },
};
